/* eslint-disable */
import React, {Component} from 'react';

import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import Classes from './NextSongControllable.css'
import NextSongControllableItem     from './NextSongControllableItem/NextSongControllableItem';
import Aux              from '../../hoc/Aux';
import FlipMove         from 'react-flip-move';
import logger           from './../../logger';
import config      from './../../moramma-config.json';
import axios        from 'axios';

class NextSongControllable extends Component {

    fmtMSS = (s) => {return(s-(s%=60))/60+(9<s?'.':'.0')+s}

    playNowSong = (song) => {
        const localtoken = localStorage.getItem('API');
        if (!localtoken) {
         logger.error('[NextSongControllable|playNowSong] Local token not found');
          return;
        }
    
        // console.log(song);
        axios({
          method: 'put',
          url: `${config.BASE_API}/rooms/${this.props.roomName}/songs/${song.id}/online`,
          headers: {
            Authorization: `Bearer ${localtoken}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          data: { token: localtoken, user: this.props.roomName }
        }).then(() => {
          // logger.debug('[ManagerScreen|skipSong] song goes online');
          ToastsStore.success('done.');
        }).catch(err => {
          ToastsStore.warning('Error');
          console.error('[ManagerScreen|skipSong] error during API/rooms/x/songs/x/online', err);
        });
      }

      moveUpSong = (song) => {
        const localtoken = localStorage.getItem('API');
        if (!localtoken) {
         logger.error('[NextSongControllable|playNowSong] Local token not found');
          return;
        }
          const songList = this.props.songs;
        
          // console.log(songList);
          let index =  songList.findIndex((el) => el.id === song.id);
            // console.log(index);
          if(index === -1) {
            ToastsStore.warning('Index not found');
              return;
          }

          index = +index - 1;
          let maxValue = 1;
          if(songList[index]) {
              if(+songList[index].like < +song.like) {
                maxValue = +song.like + 1;
                // console.log('x');
              } else {
                maxValue = +songList[index].like + 1;
                // console.log('y');
              }
          } else {
            // console.log('z');
            index = +index + 1;
            maxValue = +songList[index].like + 1;
          }       

          // console.log('Mi aspetto unlike:', maxValue);
          // console.log('Mi aspoetto votes: ', songList[index].votes + 1);

        axios({
            method: 'put',
            url: `${config['BASE_API']}/rooms/${this.props.roomName}/songs/${song.id}/props/up/${maxValue}`,
            headers: {
              'Authorization': `Bearer ${localtoken}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
          }).then(() => {
            ToastsStore.success(`Done.`);
          }).catch(err => {
            ToastsStore.error(`An error occurred.`);
          }); 
        }

        moveDownSong = (song) => {
            const localtoken = localStorage.getItem('API');
            if (!localtoken) {
             logger.error('[NextSongControllable|playNowSong] Local token not found');
              return;
            }
              const songList = this.props.songs;
            
              // console.log(songList);
              let index =  songList.findIndex((el) => el.id === song.id);
                // console.log(index);
              if(index === -1) {
                ToastsStore.warning('An error occurred. Retry.');
                  return;
              }
    
              const maxValue = +songList[index].unlike + 1;    
              // console.log('Mi aspetto unlike:', maxValue);
              // console.log('Mi aspoetto votes: ', songList[index].votes - 1);
    
            axios({
                method: 'put',
                url: `${config['BASE_API']}/rooms/${this.props.roomName}/songs/${song.id}/props/down/${maxValue}`,
                headers: {
                  'Authorization': `Bearer ${localtoken}`,
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                }
              }).then(() => {
                ToastsStore.success(`Done.`);
              }).catch(err => {
                ToastsStore.error(`An error occurred.`);
              }); 
            }

            deleteSong = (song) => {
                const localtoken = localStorage.getItem('API');
                if (!localtoken) {
                 logger.error('[NextSongControllable|playNowSong] Local token not found');
                  return;
                }
                  const songList = this.props.songs;
                
                  // console.log(songList);
                  let index =  songList.findIndex((el) => el.id === song.id);
                    // console.log(index);
                  if(index === -1) {
                    ToastsStore.warning('Index not found');
                      return;
                  }
        
                  const maxValue = +songList[index].unlike + 1;    
                  // console.log('Mi aspetto unlike:', maxValue);
                  // console.log('Mi aspoetto votes: ', songList[index].votes - 1);
        
                axios({
                    method: 'delete', 
                    url: `${config['BASE_API']}/rooms/${this.props.roomName}/songs/${song.id}`,
                    headers: {
                      'Authorization': `Bearer ${localtoken}`,
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                    }
                  }).then(() => {
                    ToastsStore.success(`Done.`);
                  }).catch(err => {
                    
                ToastsStore.error(`An error occurred.`);
                  }); 
                }

    render() {
        let song_to_display = this.props.songs.map( song  =>  {
            // console.log(song);
            let _trend ="positive";
            if(Math.abs(song.like) < Math.abs(song.unlike) ){
                _trend = "negative"   
            }

            return <NextSongControllableItem
                    trend       = {_trend}
                    songImage   = {song.cover}
                    songName    = {song.name}
                    songAuthor  = {song.artist}
                    pictureUser = {song.user.picture}
                    key         = {song.id}
                    like        = {song.like}
                    unlike      = {song.unlike}
                    userName    = {song.user.name}
                    duration    = {this.fmtMSS(song.duration)}
                    song        = {song}
                    playNowHandler = {this.playNowSong}
                    moveUpSongHandler = {this.moveUpSong}
                    moveDownSongHandler = {this.moveDownSong}
                    deteSongHandler = {this.deleteSong}
                    userClickHandler = {this.props.userClickHandler}
                />       
        });

    return(    
        <Aux>
            <h4 className={Classes.Title}>{this.props.upcomingTitle}</h4>
            <hr/>
            <FlipMove
                enterAnimation="fade" 
                leaveAnimation="fade"
                duration="2000">
            { song_to_display }
            </FlipMove>
        </Aux>
    )
  }
}

export default NextSongControllable;